import React from 'react';

import Context     from '../../../../context';
import validations from '../../../../validations';

import { useFormik }      from 'formik';
import { useTranslation } from 'react-i18next';
import { IAcademicYearForm } from '../../../../types/academicYear.interface';

import {
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomButton2,
  CustomCheckBox,
  ResponsiveView,
} from '../../../../components';

const Create: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { showModal, setShowModal, createFunction, isLoading } = React.useContext(Context.AcademicYearScreen);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<IAcademicYearForm>({
    enableReinitialize: true,
    initialValues: {
      key      : '',
      name     : '',
      startAt  : '',
      endAt    : '',
      isCurrent: false,
    },
    validationSchema: validations.academicYear.academicYear.create,
    onSubmit: (values: IAcademicYearForm, { setSubmitting }) => {
      Promise.resolve(createFunction!(values)).catch(() => setSubmitting(false));
    },
  });

  function submitHandler(): void {
    formik.submitForm();
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  return (
    <section id="academic-year-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={'ساخت سال تحصیلی'}
        onClick={() => setShowModal!('CREATE')}
      />
      <form onSubmit={submitHandler}>
        <CustomModal label="ساخت سال تحصیلی" open={showModal === 'CREATE'} onClose={() => setShowModal!('NONE')}>
          <ResponsiveView.Container className="create-form-content">
            <br />
            <hr />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="name"
                  name="name"
                  label={'نام سال تحصیلی'}
                  placeHolder={'سال تحصیلی ۱۴۰۵ - ۱۴۰۶'}
                  value={formik.values.name}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="key"
                  name="key"
                  label={'شناسه سال'}
                  placeHolder={'1405'}
                  value={formik.values.key}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.key && formik.touched.key}
                  errorText={formik.errors.key}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="startAt"
                  name="startAt"
                  type="text"
                  label={'تاریخ شروع (میلادی)'}
                  placeHolder={'2026-09-23'}
                  value={formik.values.startAt}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.startAt && formik.touched.startAt}
                  errorText={formik.errors.startAt}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id="endAt"
                  name="endAt"
                  type="text"
                  label={'تاریخ پایان (میلادی)'}
                  placeHolder={'2027-09-22'}
                  value={formik.values.endAt}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.endAt && formik.touched.endAt}
                  errorText={formik.errors.endAt}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={12}>
                <CustomCheckBox
                  label={'سال جاری باشد'}
                  isChecked={formik.values.isCurrent}
                  onChecked={() => formik.setFieldValue('isCurrent', !formik.values.isCurrent)}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <hr />
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={() => setShowModal!('NONE')} title={t('cancel')} type="danger" />
              </ResponsiveView.Column>
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t('submit')} />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Create;
